export default __webpack_public_path__ + "not-found-404.a4d671be72e48d8ad9e8254297221171.svg";